export const BASE_MODAL_CONSTANTS = {
    CLASS_CONTAINER: '.mat-mdc-dialog-container',
    BAYMAX_CLASS_CONTAINER: '.dcl-baymax-header',
    BAYMAX_CLASS_CHILD: '.baymax-header.is-modal'
};
